module.exports = __webpack_public_path__ + "img/login-title.a68f6178.svg";